import '@babel/polyfill'
import 'nodelist-foreach-polyfill'

class Tooltip {
  constructor (node) {
    this.node = node
    this.content = null
    this.point = null
    this.styles = {
      left: 'initial',
      right: 'initial',
      bottom: 'initial'
    }
    this.init()
    this.setPosition = this.setPosition.bind(this)
  }

  show (e) {
    this.node.classList.add('-active')
    // this.setPosition(e)
  }

  hide () {
    this.node.classList.remove('-active')
  }

  setPosition (e) {
    const pointCoords = this.point.getBoundingClientRect()
    const contentCoords = this.content.getBoundingClientRect()

    console.log('inner', window.innerWidth)
    console.log('clientX', e.clientX)
    console.log('width', contentCoords.width)

    this.styles.left = e.clientX + contentCoords.width > window.innerWidth ? (window.innerWidth - e.clientX) - contentCoords.width + e.offsetX - 30 : e.offsetX - 30
    this.styles.bottom = pointCoords.top + pointCoords.height - e.clientY + 15

    this.content.style.left = this.styles.left === 'initial' ? 'initial' : this.styles.left + 'px'
    this.content.style.bottom = this.styles.bottom === 'initial' ? 'initial' : this.styles.bottom + 'px'
  }

  init () {
    this.content = document.createElement('div')
    this.content.classList.add('c-tooltip__content')
    this.content.innerText = this.node.dataset.tooltipText

    this.point = document.createElement('i')
    this.point.innerHTML = '<svg viewBox="0 0 24 24"><use xlink:href="#icon-tooltip"></use></svg>'
    this.point.addEventListener('mouseenter', (e) => this.show(e))
    this.point.addEventListener('mousemove', (e) => this.setPosition(e))
    this.point.addEventListener('mouseleave', (e) => this.hide())

    this.node.appendChild(this.point)
    this.node.appendChild(this.content)
  }
}

export default () => {
  const tooltips = document.querySelectorAll('[data-tooltip]')
  tooltips.forEach(tooltip => new Tooltip(tooltip))
}
